import { combineReducers } from "redux"
import QuestionData from "./QuestionData"
import QuestionDetails from "./QuestionDetails"
import QuestionTranslate from "./QuestionTranslate"

export default combineReducers({
    QuestionData,
    QuestionDetails,
    QuestionTranslate
  })